import { HttpErrorResponse } from '@angular/common/http';

export enum LoadingStatus {
  IDLE = 'idle',
  UPLOADING = 'uploading',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface LoadingState {
  status: LoadingStatus;
  error?: HttpErrorResponse;
}

export const createLoadingState = (): LoadingState => ({
  status: LoadingStatus.IDLE,
});

export const setLoadingState = (status: LoadingStatus, error?: HttpErrorResponse): LoadingState => ({
  status,
  error,
});

export const isLoadingState = (state: LoadingState): boolean => state.status === LoadingStatus.LOADING;
export const isErrorState = (state: LoadingState): boolean => state.status === LoadingStatus.ERROR;
export const isSuccessState = (state: LoadingState): boolean => state.status === LoadingStatus.SUCCESS;
